import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrDatePicker from '../components/FrDatePicker'
import FrTableReg from '../components/FrTableReg'
import { colors } from '../utils/vars'

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';

const swal = withReactContent(Swal)

function FaturamentoEmpresa(props) {
  const [data, setData] = useState({})
  const [dataBeneficiarios, setDataBeneficiarios] = useState([])
  const [updateType, setUpdateType] = useState(false)
  const [comboEstado, setComboEstado] = useState([{ value: '', display: '' }])
  const [enableEdit, setEnableEdit] = useState('N')

  const columnsBen = [{ id: 'pk_cto', numeric: false, label: 'Contrato', align: 'left', minWidth: 200 },
    { id: 'nomecli', numeric: false, label: 'Beneficiário', align: 'left', minWidth: 90 },
    { id: 'tipo', numeric: false, label: 'Tipo', align: 'left', minWidth: 100 },
    { id: 'data_inicio', numeric: false, label: 'Data Inicio', align: 'left', minWidth: 50 },
    { id: 'data_fim', date: true, numeric: false, label: 'Data Fim', align: 'left', minWidth: 100 },
  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('faturamento_empresa', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('faturamento_empresa', 'Inclusao'))
      }


      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/faturamento_empresa/visualizacao?pk_fat=' + query.codigo).then(r => {
          console.log(r.data)
          if (r.data) {
            setData(r.data.dataEmpresa[0])
            setDataBeneficiarios(r.data.dataBeneficiarios)
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'descricao',
      'fk_est'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (curr == 'fk_est')
        fieldName = 'Estado'
      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.host = window.location.href;
        let errors = consistData(auxValues)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/faturamento_empresa/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Registro Alterado<h2>`,
                  html: `<p style='color: ${colors.info900}'>O registro foi alterado com sucesso!</p>`,
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  html: `<p style='color: ${colors.info900}'></p>`,
                  icon: 'warning',
                })
              }
            })
          } else {
            try {
              api.post('/faturamento_empresa/add', auxValues).then(r => {
                if (r.status === 200) {
                  swal.fire({
                    title: 'Registro Adicionado',
                    text: "O registro foi adicionado com sucesso!",
                    icon: 'success',
                  }).then((result) => {
                    if (result.value) {
                      window.history.back()
                    }
                  })
                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi adicionado!",
                    icon: 'warning',
                  })
                }
              })
            } catch {
              swal.fire({
                title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                text: "O registro não foi adicionado!",
                icon: 'warning',
              })

            }

          }
        } else {
          swal.fire({
            title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };


  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>Visualização de Faturamento</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrTextInput
            maxLength='100'
            value={data.cnpj || ''}
            onChange={handleChange}
            name="cnpj"
            id="cnpj"
            color="#389492"
            label="Nome"
            variant="outlined"
            size="small"
            disabled
            style={{ width: 300 }}
          />

          <FrTextInput
            maxLength='100'
            value={data.razao_social || ''}
            onChange={handleChange}
            name="razao_social"
            id="razao_social"
            color="#389492"
            label="Razão Social"
            variant="outlined"
            size="small"
            disabled
            style={{ width: 300 }}
          />
          <FrTextInput
            maxLength='11'
            value={data.pk_fat || ''}
            onChange={handleChange}
            name="pk_fat"
            id="pk_fat"
            color="#389492"
            label="Fatura"
            variant="outlined"
            size="small"
            disabled
            style={{ width: 120 }}
          />
          <br/>
          <FrDatePicker
            value={(data.data_vencimento || '').split('T')[0]}
            color="#49573B"
            id='data_vencimento'
            name='data_vencimento'
            label="Dt. Vencimento"
            variant="outlined"
            size="small"
            style={{ width: 130 }}
            disabled
          />
          <FrTextInput
            maxLength='11'
            value={data.valor_total || ''}
            onChange={handleChange}
            name="valor_total"
            id="valor_total"
            color="#389492"
            label="Valor"
            variant="outlined"
            size="small"
            disabled
            style={{ width: 120 }}
          />
          
          <FrTextInput
            maxLength='11'
            value={data.fk_cte || ''}
            onChange={handleChange}
            name="fk_cte"
            id="fk_cte"
            color="#389492"
            label="Contrato"
            variant="outlined"
            size="small"
            disabled
            style={{ width: 120 }}
          />
          <FrTextInput
            maxLength='11'
            value={data.competencia || ''}
            onChange={handleChange}
            name="competencia"
            id="competencia"
            color="#389492"
            label="Competência"
            variant="outlined"
            size="small"
            disabled
            style={{ width: 120 }}
          />
          <br/>
          <div className="tableDiv">
              <FrTableReg 
                dense 
                readOnly 
                detail 
                regName="contratos" 
                columns={columnsBen} 
                searched={false} 
                codeName="pk" 
                page={''} 
                data={dataBeneficiarios} 
              />

            </div>
          



        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default FaturamentoEmpresa;
